"use client";

import { memo, useRef } from "react";
import dynamic from "next/dynamic";
import classNames from "classnames";
import Input from "@/components/common/shared/Input/input";
import { useSearchItems } from "@/lib/hooks/useSearchItems";

const Suggestions = dynamic(() => import("./SuggestionBox"), {
  ssr: false,
});

const Placeholder = dynamic(() => import("./Placeholder"), {
  ssr: false,
});

const MemoPlaceholder = memo(Placeholder);

const SearchComponent = ({ t, routes, router }) => {
  const lastCleanedValueRef = useRef("");
  const {
    data: { searching, isFocused, searchTerm, isSearched, suggestions },
    methods: {
      setIsFocused,
      enterKeyHandler,
      handleResultLink,
      handleClearSearch,
      queryToSearchItems,
      handleSearchChange,
    },
  } = useSearchItems({
    t,
    routes,
    router,
    afterSearch: () => {
      document.body.style.overflow = "unset";
    },
  });

  return (
    <>
      <div
        className={classNames("searchBox", {
          focused: isFocused,
          suggestions: isFocused && (searching || isSearched),
        })}
      >
        <Input
          type="search"
          id="desktop-search"
          placeholder="Search for parts"
          defaultValue={searchTerm}
          onKeyDown={enterKeyHandler}
          onClear={handleClearSearch}
          onSearch={queryToSearchItems}
          onFocus={() => setIsFocused(true)}
          icon="search"
          clearIcon={!!searchTerm}
          onChange={(e) => {
            const value = e.target.value;
            const trimmedValue = value.trim();
            if (trimmedValue === "") {
              return;
            }
            if (trimmedValue === lastCleanedValueRef.current) {
              return;
            }
            lastCleanedValueRef.current = trimmedValue;
            setIsFocused(true);
            handleSearchChange(e);
          }}
          onBlur={() =>
            setTimeout(() => {
              setIsFocused(false);
            }, 500)
          }
        />

        {!searchTerm && <MemoPlaceholder t={t} isFocused={isFocused} />}
        <div className="search-suggestion-box">
          <Suggestions
            routes={routes}
            isFetching={searching}
            searchTerm={searchTerm}
            suggestions={suggestions}
            handleResultLink={handleResultLink}
          />
        </div>
      </div>

      <div
        tabIndex={0}
        role="button"
        className="search-bg"
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
      ></div>
    </>
  );
};

export default SearchComponent;
